import { useLocation } from "react-router-dom";
import bg1 from "@/assets/bg-house-1.jpg";
import bg2 from "@/assets/bg-house-2.jpg";
import bg3 from "@/assets/bg-house-3.jpg";
import bg4 from "@/assets/bg-house-4.jpg";

const routeMap: Record<string, string> = {
  "/": bg1,
  "/leibrente": bg2,
  "/teilverkauf": bg3,
  "/rueckmiete": bg4,
  "/niessbrauch": bg1,
  "/wohnrecht": bg2,
  "/seniorenfinanzierung": bg3,
  "/erfolgsgeschichten": bg4,
};

const PageBackground = () => {
  const { pathname } = useLocation();
  const src = routeMap[pathname] ?? bg1;

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
    >
      <img
        src={src}
        alt=""
        className="w-full h-full object-cover opacity-20"
        loading="lazy"
      />
    </div>
  );
};

export default PageBackground;
